import { render, staticRenderFns } from "./AddressWidget.vue?vue&type=template&id=6d4b3aff&scoped=true"
import script from "./AddressWidget.vue?vue&type=script&lang=js"
export * from "./AddressWidget.vue?vue&type=script&lang=js"
import style0 from "./AddressWidget.vue?vue&type=style&index=0&id=6d4b3aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b3aff",
  null
  
)

export default component.exports